import React from "react";
import moment from "moment";
import { useSelector } from "types/store";
import { getIsTableauMode } from "containers/App/reducer";
import { getIsTabUploading } from "containers/Login/reducer";
import SenseTile from "components/Tiles/Sense/SenseTile";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import CSVIconGray from "images/csv_light_grey.svg";
import styles from "./style.module.css";
import { getEntities } from "containers/Sense/reducer";
import * as viewReducer from "containers/View/reducer";
import AgentAutonomyControls from "components/AgentAutonomy/AgentAutonomyControls";
import { isEnabled } from "utils/featureFlags";
const TabUploadSenseTile = () => {
    const tileHeaderBackground = "#C8CAD4";
    const isPinned = false;
    return (React.createElement("div", { className: styles.senseTile, id: "dataset_tableau" },
        React.createElement("div", { className: styles.tileHeader, style: { background: tileHeaderBackground, color: "#4B495B" } },
            React.createElement("div", { className: styles.tFlex },
                React.createElement("img", { src: CSVIconGray, style: {
                        height: "30px",
                        width: "30px",
                        marginRight: "5px",
                        background: "transparent"
                    } }),
                React.createElement("div", { style: { width: "100%" } },
                    React.createElement("div", null,
                        React.createElement("span", null, "TABLEAU"),
                        React.createElement("span", { style: { marginLeft: "5px" }, title: moment.utc().local().format("MMMM Do YYYY, h:mm:ss a") }, moment.utc().local().fromNow())),
                    React.createElement("div", { className: styles.tileHeaderLarge, style: isPinned ? { maxWidth: "90%" } : {} }, "Importing Data...")))),
        React.createElement("div", { className: styles.tileBody },
            React.createElement("div", { className: styles.senseAll },
                React.createElement("div", { className: styles.openOverview, style: { zIndex: 10, width: "100%" } },
                    React.createElement(LoadingIndicator, null),
                    React.createElement("div", { className: styles.senseTitle, style: { justifyContent: "center" } }, "Importing Data from Tableau Workbook"))))));
};
const SenseTileList = () => {
    const entities = useSelector((state) => getEntities(state));
    const isTableauMode = useSelector((state) => getIsTableauMode(state));
    const isTabUploading = useSelector((state) => getIsTabUploading(state));
    const rawViewSearch = useSelector((state) => viewReducer.getSearch(state));
    const corpusList = useSelector((state) => viewReducer.getCorpusList(state)) ?? [];
    // We can actually set this by the width of the screen!
    // Maybe we use the autosizer to get the width?
    const NUM_COLUMNS = isTableauMode ? 1 : 3;
    const dataByColumn = [];
    for (let i = 0; i < NUM_COLUMNS; i++) {
        dataByColumn[i] = [];
    }
    const viewSearch = String(rawViewSearch).toLowerCase();
    const retEntities = entities.filter((d) => {
        let canViewData = viewSearch === undefined || viewSearch === "" || d?.[1] === "DATASET";
        if (d?.[1] === "CORPUS" && viewSearch !== undefined) {
            const cItem = corpusList.find((c) => c.id === d?.[0]);
            if (cItem && cItem.id && String(cItem.id).toLowerCase().indexOf(viewSearch) !== -1) {
                canViewData = true;
            }
            if (cItem && cItem.name && cItem.name.toLowerCase().indexOf(viewSearch) !== -1) {
                canViewData = true;
            }
            if (cItem && cItem.created_by?.fullname && cItem.created_by?.fullname.toLowerCase().indexOf(viewSearch) !== -1) {
                canViewData = true;
            }
        }
        return canViewData;
    });
    retEntities.forEach((d, i) => {
        dataByColumn[i % NUM_COLUMNS].push(d);
    });
    return (React.createElement("div", { className: styles.senseTilesHolder },
        React.createElement("div", { className: styles.senseBoard, style: isEnabled("agent-autonomy-controls") ? { minHeight: "240px" } : undefined }, dataByColumn.map((columnData, i) => (React.createElement("div", { className: styles.column, key: "column_" + i },
            i === 0 && isTabUploading === true && React.createElement(TabUploadSenseTile, null),
            columnData && columnData.map(([id, type]) => React.createElement(SenseTile, { key: id, id: id, type: type })))))),
        isEnabled("agent-autonomy-controls") && React.createElement(AgentAutonomyControls, { isDataView: true })));
};
export default SenseTileList;
